import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

import { clearState, setUdn} from "../../../redux/actions/generalActions/mainActions";
import { showLoader } from "../../../components/loader/loader";
import SearchXt  from "../../../components/searchxt/searchXt";
import {TT_DELETE, TT_EDIT, TT_NODE_ADD} from "../../../components/i18n/toolTips";
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST, NO, NO_DATA_FOUND, YES
} from "../../../components/i18n/i18n";
import { confirmAlert } from 'react-confirm-alert';
import XtorageFileForm from "./_form";

import CardXt from "../../../components/cardsxt/cardXt";

const XtorageFile = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            props.remove(data.id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const onNew = () => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <XtorageFileForm onClose={onClose} save={props.save}/>
                );
            }
        });
    };

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => {
            props.setViewMode('FORM');
            props.setItem(row);
            props.setForm(true, false, false);
        }}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const confirmDeleteObject = () => {
        console.log('No implementado')
    }

    const confirmEditObject = () => {
        console.log('No implementado')
    }

    const confirmAddEditNode = () => {
        console.log('No implementado')
    }

    return (
        <>
            { loading ? showLoader() : null}
            <div className="border-bottom">
                <h2 className="pb-2 text-center font-bold text-xtorage" >¡Busca los archivos que necesitas aquí!</h2> 
                <SearchXt />
            </div> 
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return (
                                    <div>             
                                        <Row>
                                            <Col md="6">
                                                <h3 className="pt-4 pb-4 font-bold text-xtorage">Resultados</h3> 

                                            </Col>  
                                            <Col md="6">
                                                <div className="pt-4 pb-4 float-right ">
                                                    <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={confirmDeleteObject} />
                                                    <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={confirmEditObject}/>
                                                    <GenericTableButton toolTip={TT_NODE_ADD} icon={'fa-plus'} permission={'edit'} onClick={onNew}/>
                                                </div>   
                                            </Col>  
                                        </Row>         
                                        <Row>
                                            <Col className="col-sm"><CardXt/></Col>
                                            <Col className="col-sm"><CardXt/></Col>
                                            <Col className="col-sm"><CardXt/></Col>
                                            <Col className="col-sm"><CardXt/></Col>
                                        </Row>
                                    </div>)
                                    
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
});

export default connect(mapStateToProps, mapActionsToProps)(XtorageFile)
